module.exports = __webpack_public_path__ + "img/workspace-onboarding/record-a-video-7a233aa75fe81b81b4ec05b5f201b92a.png";